module.exports = __webpack_public_path__ + "media/luxury-2026/location-kitchen-2ce9a051.jpg";